import styled from 'styled-components'

export const LiftedFraction = styled.span`
	font-size: 75%;
	vertical-align: 0.25em;
`
